import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import QRCode from 'react-qr-code';
import { useMediaQuery } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

// CONSTANTS
import { mobileAppDownloadLink, mobileAppDownloadLinkQR } from '@/constants/common';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';
import { customAnalyticsEvent } from '@/utility/analytics';

const appleStoreIcon = getS3ImageUrl('/icons/download-app-store.svg');
const googlePlayIcon = getS3ImageUrl('/icons/download-google-play.svg');

const DownloadApp = () => {
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const { partnerSettings } = useSelector(({ partner: partnerStore }) => ({
    partnerSettings: partnerStore.data?.settings || {},
  }));
  const downloadLink = partnerSettings.mobile_app_download_link || mobileAppDownloadLink;
  const downloadLinkQR =
    partnerSettings.mobile_app_download_link || mobileAppDownloadLinkQR || mobileAppDownloadLink;

  if (!downloadLink) return null;

  const handleDownloadClick = store => {
    customAnalyticsEvent('Download App Clicked', { store, link: downloadLink });
  };

  return (
    <div className="download-app section section--grey">
      <div className="page-content">
        <Typography className="download-app__title text-medium m-b-25" align="center" variant="h3">
          {t(`mobileApp.downloadApp.${downXs ? 'titleMob' : 'title'}`)}
        </Typography>
        {!downXs && (
          <div className="download-app__qr">
            <QRCode value={downloadLinkQR} size={174} />
          </div>
        )}
        {downXs && (
          <Typography className="m-b-15" align="center" variant="h6">
            {t('mobileApp.downloadApp.links.title')}
          </Typography>
        )}
        {downXs && (
          <div className="download-app__links">
            <a
              href={downloadLink}
              target="_blank"
              rel="noreferrer"
              onClick={() => handleDownloadClick('apple-store')}
            >
              <img src={appleStoreIcon} alt="apple-store" />
            </a>
            <a
              href={downloadLink}
              target="_blank"
              rel="noreferrer"
              onClick={() => handleDownloadClick('google-play')}
            >
              <img src={googlePlayIcon} alt="google-play" />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(DownloadApp);
